import React from 'react'
import PropTypes from 'prop-types'
import { Table, Margin, Button, Text } from 'shared/components'
import { TeamAthletesFilters } from './components/filters'

const TeamAthletesComponent = ({
  columns,
  loadAthletes,
  onSearch,
  onRequestClose,
}) => {
  return (
    <>
      <Margin tb={2}>
        <TeamAthletesFilters debounce={250} onSearch={onSearch} />
      </Margin>
      <Table
        id="team-athletes-table"
        columns={columns}
        loadData={loadAthletes}
      />
      <Margin top={5}>
        <Button outlined medium green onClick={() => onRequestClose()}>
          <Text size={16} bold black>
            Close
          </Text>
        </Button>
      </Margin>
    </>
  )
}

TeamAthletesComponent.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape()),
  loadAthletes: PropTypes.func,
  onSearch: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func,
}

export default TeamAthletesComponent
